import { defineNuxtPlugin, reloadNuxtApp } from 'nuxt/app';
import { useCookie } from '~/composables/useCookie';
import { EGlobalStoreEnums } from '~/composables/useGlobal';
import { useUserStore } from '~/stores/user';

export default defineNuxtPlugin((nuxtApp) => {
  const fetch = globalThis.$fetch;

  globalThis.$fetch = ((...args: any[]) => {
    return fetch(...args).catch(async (error) => {
      const _401 = error?.response?.status === 401;
      const _500_InvalidToken =
        error?.response?.status === 500 &&
        error?.response?.statusText === 'Invalid or expired JWT';

      if (_401 || _500_InvalidToken) {
        const userStore = useUserStore();
        const accessToken = useCookie('accessToken');
        const adminNumber = useCookie('adminNumber');

        accessToken.value = null;
        adminNumber.value = null;

        localStorage.removeItem(EGlobalStoreEnums.RAP_USER_ROLES);
        userStore.logOut();

        reloadNuxtApp({ path: '/auth/login', ttl: 100 });
      } else throw error;
    });
  }) as typeof $fetch;
});
